import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useMutation, useQuery } from "@apollo/client";
import { DELETE_ROLE, ARCHIVE_JOB } from "../../../GraphQL/roles/mutations";
import { GET_ROLE_BY_ID } from "../../../GraphQL/roles/queries";
import { EToastColorStatus, EToastPosition } from "../../../interfaces";

interface IProps {
  id: number | null;
  show: boolean;
  onHideModal: () => void;
  reloadRoles: () => void;
  onCreateToast?: (
    color: EToastColorStatus,
    position: EToastPosition,
    message: string,
  ) => void;
}

const RoleDeleteModal = ({id, show, onHideModal, reloadRoles, onCreateToast = () => {}}: IProps) => {
  const { loading, data } = useQuery(GET_ROLE_BY_ID, { variables: { id: Number(id) } });

  const [deleteRole] = useMutation(DELETE_ROLE, {
    onCompleted(){
      reloadRoles();
      onHideModal();
      onCreateToast(
        EToastColorStatus.SUCCESS,
        EToastPosition.BOTTOM_END,
        "Role deleted!",
      );
    },
    onError(error: any) {
      const errorMessage = error?.networkError?.result?.errors[0]?.message;
      onHideModal();
      onCreateToast(
        EToastColorStatus.FAILED,
        EToastPosition.BOTTOM_END,
        errorMessage,
      );
    },
  });

  const [archiveJob] = useMutation(ARCHIVE_JOB, {
    onCompleted(){
      reloadRoles();
      onHideModal();
      onCreateToast(
        EToastColorStatus.SUCCESS,
        EToastPosition.BOTTOM_END,
        "Role archived!",
      );
    },
  });

  const handleDeleteRole = () => {
    if (id === null) return
    deleteRole({
      variables: {
        jobId: Number(id),
      },
    });
  }

  const handleArchiveRole = () => {
    if (id === null) return
    archiveJob({
      variables: {
        jobId: `${id}`,
      },
    });
  }

  if (loading) {
    return (
      <Dialog open={show} onOpenChange={onHideModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Loading...</DialogTitle>
          </DialogHeader>
          <div>Loading...</div>
        </DialogContent>
      </Dialog>
    )
  };

  if (data?.jobs?.items[0]?.matches > 0) {
    return (
      <Dialog open={show} onOpenChange={onHideModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Archive Role</DialogTitle>
          </DialogHeader>
          <div className="py-4">
            This role can not be deleted due to associated matches.
            Do you wish to archive this role instead?
            Archived roles are hidden from your list of roles.
          </div>
          <DialogFooter>
            <Button variant="secondary" onClick={onHideModal}>
              Cancel
            </Button>
            <Button variant="destructive" onClick={handleArchiveRole}>
              Archive
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Dialog open={show} onOpenChange={onHideModal}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Role</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          Are you want to delete this role? This process cannot be undone.
        </div>
        <DialogFooter>
          <Button variant="secondary" onClick={onHideModal}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleDeleteRole}>Delete</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default RoleDeleteModal;
